"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartIconRoot = exports.FavoritesTitle = exports.FavoritesRoot = void 0;
var _mui = require("@ori-ui/mui");
const FavoritesRoot = exports.FavoritesRoot = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  padding: theme.spacing(5, 3, 2, 3),
  textDecoration: 'none',
  '&:active, &:focus': {
    WebkitTapHighlightColor: 'transparent'
  }
}));
const FavoritesTitle = exports.FavoritesTitle = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  fontSize: '1.7rem',
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: '2.9rem',
  marginLeft: theme.spacing(2)
}));
const HeartIconRoot = exports.HeartIconRoot = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  display: 'flex',
  fontSize: '2.9rem'
}));